// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n5-0";
export var assigneeDetails = "_n5-1";
export var assigneeInfo = "_n5-2";
export var dropdownContainer = "_n5-4";
export var dropdownImage = "_n5-5";
export var editAssigneeInfo = "_n5-3";
export var editAssigneeModalContainer = "_n5-6";
export var hidden = "_n5-8";
export var input = "_n5-7";